import { Type, Field, Name } from 'serialize-ts';

import { BaseHttpError } from '~shared/modules/error-handler/models/base-http-error.model';

import { InvalidParams } from './invalid-params.model';
import { InvalidParamsSerializer } from '../classes/css-invalid-params-serializer.class';

export class CSSHttpError extends BaseHttpError {
  @Field()
  status: number;

  @Field()
  title: string;

  @Field()
  detail: string;

  @Field()
  @Name('validationErrors')
  @Type(new InvalidParamsSerializer())
  invalidParams: InvalidParams = {};
  
  @Field()
  message: string;
}
